import { Option } from '../../../../components/SelectOption/SelectOption';
import i18n from '../../../../infrastructure/i18n';
const OutputStateAction = {
  ENABLE: '1',
  DISABLE: '0',
};

export const enableOption: Option = {
  id: OutputStateAction.ENABLE,
  value: i18n.t('statuses.output.actions.enable'),
};

export const disableOption: Option = {
  id: OutputStateAction.DISABLE,
  value: i18n.t('statuses.output.actions.disable'),
};

export const outputChangeOptions: Option[] = [enableOption, disableOption];